export enum NftStatus {
  Minting = 'minting',
  Minted = 'minted',
  Listed = 'listed',
  Assigned = 'assigned',
  Claiming = 'claiming',
  Claimed = 'claimed',
}
